
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search-input');
  const clearBtn = document.getElementById('clear-search-btn');
  const accordionDetails = document.querySelectorAll('accordion-custom details');

  if (searchInput && accordionDetails.length > 0) {  
    searchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();
      let hasResult = false;

      accordionDetails.forEach(details => {
        const question = details.querySelector('summary').innerText.toLowerCase();
        const answer = details.querySelector('.details-content').innerText.toLowerCase();

        if (query === '') {
          details.style.display = '';
          details.removeAttribute('open'); // Close all when empty
          return;
        }

        if (question.includes(query) || answer.includes(query)) {
          details.style.display = '';
          details.setAttribute('open', '');  // Open only the matching items
          hasResult = true;
        } else {
          details.style.display = 'none';    // Hide non-matching items
          details.removeAttribute('open');
        }
      });

      const noResult = document.querySelector('#no-result');
      if (noResult) {
        noResult.style.display = hasResult ? 'none' : 'block'; // Hide or Show no results message
      }
    });

    // Clear button event → Show all accordions & Close all accordions
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        // Reset the input field
        searchInput.value = '';

        accordionDetails.forEach(details => {
          details.style.display = '';       // Show accordions
          details.removeAttribute('open');  // Close accordions
        });

        // Hide no result message
        const noResult = document.querySelector('#no-result');
        if (noResult) noResult.style.display = 'none';
      });
    }
  }
});
